module.exports = __webpack_public_path__ + "img/login.56a0c0a5.svg";